var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot3Getstartd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 10,
    viewBox: "0 0 56 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319234"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 967",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 968",
    cx: 20,
    cy: 5,
    r: 5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 969",
    cx: 35,
    cy: 5,
    r: 5,
    fill: "#240b3b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 970",
    cx: 50,
    cy: 5,
    r: 5,
    fill: "#D9D9D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot3Getstartd);
export default __webpack_public_path__ + "static/media/dot3-getstartd.712109059d80f2f6ce970e43b1e32b48.svg";
export { ForwardRef as ReactComponent };